// Quick View Variant's Image Change
const DEBUG = {
    enabled: false,
    log: function(...args) {
      if (this.enabled) {
        console.log('[Quick Add Debug]', ...args);
      }
    },
    error: function(...args) {
      if (this.enabled) {
        console.error('[Quick Add Debug]', ...args);
      }
    }
  };
 
  function debounce(func, wait) {
     let timeout;
     return function executedFunction(...args) {
       const later = () => {
         clearTimeout(timeout);
         func(...args);
       };
       clearTimeout(timeout);
       timeout = setTimeout(later, wait);
     };
   }
 
   let cachedElements = {
     mainImage: null,
     variantContainer: null,
     variantJson: null
   };

   // Store the target variant ID to preselect
   let targetVariantId = null;
 
   function initializeGallery() {
     DEBUG.log('Initializing gallery...');
     
     const waitForElements = setInterval(() => {
       cachedElements.mainImage = document.querySelector('[data-gallery-image]');
       cachedElements.variantContainer = document.querySelector('[data-product-variants]');
       
       DEBUG.log('Checking for elements...');
       DEBUG.log('Main image element:', cachedElements.mainImage);
       DEBUG.log('Variant container:', cachedElements.variantContainer);
       
       if (cachedElements.mainImage && cachedElements.variantContainer) {
         clearInterval(waitForElements);
         DEBUG.log('Elements found, proceeding with initialization');
         setupGallery();
       }
     }, 100);
 
     setTimeout(() => {
       clearInterval(waitForElements);
     }, 5000);
   }

   function preselectVariant(variantId) {
     DEBUG.log('=== PRESELECT VARIANT START ===');
     DEBUG.log('Attempting to preselect variant:', variantId);
     
     if (!cachedElements.variantJson || !variantId) {
       DEBUG.log('No variant JSON or variant ID available for preselection');
       return;
     }

     const targetVariant = cachedElements.variantJson.find(variant => variant.id == variantId);
     
     if (!targetVariant) {
       DEBUG.log('Target variant not found:', variantId);
       DEBUG.log('Available variants:', cachedElements.variantJson.map(v => ({ id: v.id, options: v.options })));
       return;
     }

     DEBUG.log('Found target variant:', targetVariant);
     
     // Debug DOM structure
     DEBUG.log('Current DOM structure:');
     DEBUG.log('- Product variants container:', document.querySelector('[data-product-variants]'));
     DEBUG.log('- All variant buttons:', document.querySelectorAll('[data-product-variants] button[data-option-value]'));
     DEBUG.log('- All swatch displays:', document.querySelectorAll('[data-swatch-selected]'));
     DEBUG.log('- All color swatch values:', document.querySelectorAll('.product__color-swatch-value'));

     // Update variant selections based on the target variant's options
     targetVariant.options.forEach((optionValue, index) => {
       DEBUG.log(`Setting option ${index + 1} to: ${optionValue}`);
       
       // Handle select dropdowns - use more specific selectors
       const selectInput = document.querySelector(`[data-product-variants] select#option${index + 1}, [data-product-variants] select[name="options[${Object.keys(targetVariant.option_names || {})[index] || index}]"]`);
       if (selectInput) {
         selectInput.value = optionValue;
         selectInput.dispatchEvent(new Event('change', { bubbles: true }));
         DEBUG.log('Updated and triggered change on select input:', selectInput);
       }

       // Handle button-based options (chips/swatches)
       const buttonSelector = `[data-product-variants] button[data-option-value="${optionValue}"]`;
       const targetButton = document.querySelector(buttonSelector);
       
       DEBUG.log('Button selector:', buttonSelector);
       DEBUG.log('Found target button:', targetButton);
       
       if (targetButton) {
         // Remove selected class from all buttons in the same option group
         const optionGroup = targetButton.closest('.product__option, .product__color-chips, [data-option-buttons]');
         DEBUG.log('Found option group:', optionGroup);
         
         if (optionGroup) {
           optionGroup.querySelectorAll('button').forEach(btn => btn.classList.remove('selected'));
           targetButton.classList.add('selected');
           
           // Update the color swatch value display text - try multiple selectors
           const swatchValueSelectors = [
             '[data-swatch-selected]',
             '.product__color-swatch-value',
             '.product__option-value',
             '.swatch-value'
           ];
           
           let swatchValueDisplay = null;
           for (const selector of swatchValueSelectors) {
             swatchValueDisplay = optionGroup.querySelector(selector);
             if (swatchValueDisplay) {
               DEBUG.log('Found swatch value display with selector:', selector, swatchValueDisplay);
               break;
             }
           }
           
           if (swatchValueDisplay) {
             const oldValue = swatchValueDisplay.textContent;
             swatchValueDisplay.textContent = optionValue;
             DEBUG.log('Updated swatch value display from:', oldValue, 'to:', optionValue);
           } else {
             DEBUG.log('No swatch value display found. Available elements in option group:', optionGroup.innerHTML);
           }
           
           // Also update the associated hidden select if it exists
           const hiddenSelect = optionGroup.querySelector('select');
           if (hiddenSelect) {
             hiddenSelect.value = optionValue;
             hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
             DEBUG.log('Updated hidden select:', hiddenSelect);
           }
           
           DEBUG.log('Selected button and triggered events:', targetButton);
         }
       } else {
         DEBUG.log('No button found for option value:', optionValue);
         DEBUG.log('Available buttons:', document.querySelectorAll('[data-product-variants] button[data-option-value]'));
       }
     });

     // Update the main image if the variant has a featured image
     if (targetVariant.featured_image && cachedElements.mainImage) {
       let newImageSrc = targetVariant.featured_image.src;
       
       if (newImageSrc.includes('_500x')) {
         newImageSrc = newImageSrc.replace(/_500x/g, '_500x');
       } else {
         newImageSrc = newImageSrc.replace(/(\.[^.]+)$/, '_500x$1');
       }
       
       DEBUG.log('Updating main image to:', newImageSrc);
       
       const tempImage = new Image();
       tempImage.onload = function() {
         cachedElements.mainImage.src = newImageSrc;
         cachedElements.mainImage.alt = targetVariant.featured_image.alt || '';
       };
       tempImage.src = newImageSrc;
     }

     // Update the variant container with the current variant ID
     if (cachedElements.variantContainer) {
       cachedElements.variantContainer.setAttribute('data-current-variant-id', targetVariant.id);
       DEBUG.log('Updated variant container ID to:', targetVariant.id);
     }

     // Update any hidden variant ID inputs
     const variantIdInputs = document.querySelectorAll('input[name="id"], select[name="id"]');
     variantIdInputs.forEach(input => {
       input.value = targetVariant.id;
       DEBUG.log('Updated variant ID input:', input);
     });
     
     DEBUG.log('=== PRESELECT VARIANT END ===');
   }

 
   function setupGallery() {
     const variantInputs = document.querySelectorAll('[data-product-variants] select, [data-product-variants] button');
     DEBUG.log('Found variant inputs:', variantInputs.length);
     if (variantInputs.length === 0) {
       DEBUG.log('No variant inputs found, returning');
       return;
     }

     const variantJsonElement = document.querySelector('[data-variant-json]');
     if (variantJsonElement) {
       try {
         cachedElements.variantJson = JSON.parse(variantJsonElement.textContent);
         DEBUG.log('Successfully parsed variant JSON:', cachedElements.variantJson);
         
         // Preselect the target variant if specified
         DEBUG.log('Checking for target variant ID:', targetVariantId);
         if (targetVariantId) {
           DEBUG.log('Target variant ID found, calling preselectVariant in 100ms...');
           setTimeout(() => {
             preselectVariant(targetVariantId);
             targetVariantId = null; // Reset after use
           }, 100);
         } else {
           DEBUG.log('No target variant ID found, skipping preselection');
         }
       } catch (e) {
         DEBUG.error('Error parsing variant JSON:', e);
         return;
       }
     } else {
       DEBUG.log('No variant JSON element found');
     }
 
     const updateVariant = debounce(function(selectedOptions) {
       DEBUG.log('Updating variant with options:', selectedOptions);
       if (!cachedElements.variantJson) {
         DEBUG.log('No variant JSON available');
         return;
       }
 
       const matchingVariant = cachedElements.variantJson.find(variant => {
         return variant.options.every((option, index) => {
           const optionName = Object.keys(selectedOptions)[index];
           return variant.options[index] === selectedOptions[optionName];
         });
       });
 
       DEBUG.log('Matching variant:', matchingVariant);
 
              if (matchingVariant) {
         if (cachedElements.variantContainer) {
           cachedElements.variantContainer.setAttribute('data-current-variant-id', matchingVariant.id);
           DEBUG.log('Updated variant container ID to:', matchingVariant.id);
         }

         // Update swatch value displays for all options
         matchingVariant.options.forEach((optionValue, index) => {
           DEBUG.log(`Updating swatch display for option ${index + 1}: ${optionValue}`);
           
           // Find the corresponding option group
           const optionGroups = document.querySelectorAll('[data-product-variants] .product__option');
           if (optionGroups[index]) {
             const optionGroup = optionGroups[index];
             
             // Try multiple selectors for swatch value display
             const swatchValueSelectors = [
               '[data-swatch-selected]',
               '.product__color-swatch-value',
               '.product__option-value',
               '.swatch-value'
             ];
             
             let swatchValueDisplay = null;
             for (const selector of swatchValueSelectors) {
               swatchValueDisplay = optionGroup.querySelector(selector);
               if (swatchValueDisplay) {
                 DEBUG.log('Found swatch value display with selector:', selector, swatchValueDisplay);
                 break;
               }
             }
             
             if (swatchValueDisplay) {
               const oldValue = swatchValueDisplay.textContent;
               swatchValueDisplay.textContent = optionValue;
               DEBUG.log('Updated swatch value display from:', oldValue, 'to:', optionValue);
             } else {
               DEBUG.log('No swatch value display found in option group:', optionGroup.innerHTML);
             }
           }
         });

         if (matchingVariant.featured_image) {
           const currentSrc = cachedElements.mainImage.src;
           let newImageSrc = matchingVariant.featured_image.src;
           
           DEBUG.log('Current image src:', currentSrc);
           DEBUG.log('New image src before processing:', newImageSrc);
           
           if (newImageSrc.includes('_500x')) {
             newImageSrc = newImageSrc.replace(/_500x/g, '_500x');
           } else {
             newImageSrc = newImageSrc.replace(/(\.[^.]+)$/, '_500x$1');
           }
           
           DEBUG.log('Processed new image src:', newImageSrc);
           
           if (currentSrc !== newImageSrc) {
             DEBUG.log('Image source will change');
             const tempImage = new Image();
             tempImage.onload = function() {
               DEBUG.log('New image loaded successfully');
               cachedElements.mainImage.src = newImageSrc;
               cachedElements.mainImage.alt = matchingVariant.featured_image.alt || '';
             };
             tempImage.onerror = function() {
               DEBUG.error('Failed to load new image:', newImageSrc);
             };
             tempImage.src = newImageSrc;
           } else {
             DEBUG.log('Image source unchanged');
           }
         } else {
           DEBUG.log('No featured image for this variant');
         }
       } else {
         DEBUG.log('No matching variant found');
       }
     }, 100);
 
    variantInputs.forEach(input => {
      input.addEventListener('change', function() {
        DEBUG.log('Variant input changed:', this);
        const selectedOptions = {};
        document.querySelectorAll('[data-product-variants] select, [data-product-variants] button[data-option-value]').forEach(input => {
          if (input.tagName === 'SELECT') {
            selectedOptions[input.name.replace('options[', '').replace(']', '')] = input.value;
          } else if (input.classList.contains('selected')) {
            const optionGroup = input.closest('.product__option');
            if (optionGroup) {
              const optionLabel = optionGroup.querySelector('.product__label');
              if (optionLabel) {
                const optionName = optionLabel.textContent.trim();
                selectedOptions[optionName] = input.getAttribute('data-option-value');
              }
            }
          }
        });
        DEBUG.log('Collected selected options:', selectedOptions);
        updateVariant(selectedOptions);
      });
    });
 
    const handleButtonClick = debounce(function(button) {
      DEBUG.log('Button clicked:', button);
      const optionGroup = button.closest('.product__option');
      
      // Add null check to prevent TypeError
      if (!optionGroup) {
        DEBUG.log('Warning: option group not found for button:', button);
        return;
      }
      
      optionGroup.querySelectorAll('button').forEach(btn => btn.classList.remove('selected'));
      button.classList.add('selected');
      
      const firstInput = optionGroup.querySelector('select');
      if (firstInput) {
        firstInput.value = button.getAttribute('data-option-value');
        DEBUG.log('Dispatching change event on select with value:', firstInput.value);
        firstInput.dispatchEvent(new Event('change'));
      }
    }, 100);
 
     document.querySelectorAll('[data-product-variants] button[data-option-value]').forEach(button => {
       button.addEventListener('click', function() {
         handleButtonClick(this);
       });
     });
   }
 
   document.addEventListener('click', function(event) {
     const quickAddButton = event.target.closest('[data-quick-add]');
     if (quickAddButton) {
       DEBUG.log('Quick add button clicked:', quickAddButton);
       const quickAddEvent = new CustomEvent('quickAddOpened', {
         detail: {
           productId: quickAddButton.dataset.productId,
           productHandle: quickAddButton.dataset.quickAdd,
           variantId: quickAddButton.dataset.productId // data-product-id is actually variant-id
         }
       });
       document.dispatchEvent(quickAddEvent);
     }
   });
 
   document.addEventListener('quickAddOpened', function(event) {
     DEBUG.log('=== QUICK ADD OPENED EVENT ===');
     DEBUG.log('Quick add opened event received:', event.detail);
     
     // Store the target variant ID for preselection
     if (event.detail.variantId) {
       targetVariantId = event.detail.variantId;
       DEBUG.log('Target variant ID set to:', targetVariantId);
     }
     
     setTimeout(function() {
       DEBUG.log('Initializing gallery after quick add opened...');
       initializeGallery();
     }, 300);
   });
 
   document.addEventListener('DOMContentLoaded', function() {
     DEBUG.log('DOMContentLoaded fired');
     initializeGallery();
   });
 
   const debouncedInitialize = debounce(initializeGallery, 250);
   const observer = new MutationObserver(function(mutations) {
     mutations.forEach(function(mutation) {
       if (mutation.addedNodes.length) {
         DEBUG.log('DOM mutation detected, reinitializing gallery...');
         debouncedInitialize();
       }
     });
   });
 
   observer.observe(document.body, { 
     childList: true, 
     subtree: true 
   });
 
   // Enable debug mode by setting DEBUG.enabled = true in browser console
   window.quickAddDebug = {
     enable: function() {
       DEBUG.enabled = true;
       console.log('[Quick Add Debug] Debug mode enabled');
     },
     disable: function() {
       DEBUG.enabled = false;
       console.log('[Quick Add Debug] Debug mode disabled');
     }
   };